import React, {useCallback, useContext, useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import config from "../config.json"
import {getAuthHeader, getPathBack, removeLocalStorageItem} from "../functions"
import {AuthContext} from "../context/AuthContext"
import {useHttp} from "../hooks/http.hook"
import {LoaderClass} from "../elements/LoaderClass"

export const GoogleDriveRemovePage = () => {

    const {request, loading} = useHttp()
    const auth = useContext(AuthContext)
    const navigate = useNavigate()
    const {fileId} = useParams()
    const params = new URLSearchParams(window.location.search)
    let parent = params.get('parent')
    if (parent.length === 19) {
       parent = 'root'
    }

    const removeFile = useCallback(async () => {
        const host = window.location.host === 'localhost:3000' ? config.localHost : config.onrender
        try {
            await request(
                `${host}/api/google-drive/remove?fileID=${fileId}&redirectURI=${window.location.origin}`,
                'DELETE',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            removeLocalStorageItem(parent)
            navigate(getPathBack())
        } catch (e) {
        }
    }, [auth, fileId, request, navigate])

    useEffect(() => {
        removeFile().then()
    }, [removeFile])

    if (loading) {
        return <LoaderClass/>
    }
    return null
}